import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const CategoriaList = props => <DefaultDataTable data={props} />;
